import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useOcorrenciasOutletContext } from 'pages/Ocorrencias.context'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { Ocorrencia, ocorrencia, updateOcorrenciaSchema } from 'service/api'
import { toast } from 'sonner'
import { OcorrenciaForm } from './Form'

export default function EditarOcorrencia() {
    const { id } = useParams()
    const { data } = useOcorrenciasOutletContext()
    const o = data?.find(item => item.id === Number(id))
    const { mutateAsync, isLoading } = ocorrencia.mutations.useUpdate({
        invalidateQuery: true,
    })

    if (!o) return null

    const handleSubmit: SubmitHandler<Ocorrencia> = async data =>
        mutateAsync(data, {
            onSuccess: () => {
                toast.success('Ocorrência alterada com sucesso!')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={updateOcorrenciaSchema}
            defaultValues={o}
            open={hasPermission(['update', 'Ocorrências'])}
        >
            <Dialog.Title>Editar ocorrência</Dialog.Title>
            <Dialog.Content>
                <OcorrenciaForm />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
